import { render, staticRenderFns } from "./MinhasPessoas.vue?vue&type=template&id=44dab855&scoped=true&"
import script from "./MinhasPessoas.vue?vue&type=script&lang=js&"
export * from "./MinhasPessoas.vue?vue&type=script&lang=js&"
import style0 from "./MinhasPessoas.vue?vue&type=style&index=0&id=44dab855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dab855",
  null
  
)

export default component.exports